/*
    Global modal
*/

export default class Modal {
    constructor(options = {}) {
        const defaultOptions = {
            modalContClass: '.js-popup',
            modalTriggerClass: '.js-popup-trigger',
            modalCloseClass: '.js-popup-close',
            activeClass: '.active'
        }

        this.options = {...defaultOptions, ...options};

        this.init();
    }

    init() {
        const modalContEl = document.querySelector(this.options.modalContClass);
        const modalTriggerEls = document.querySelectorAll(this.options.modalTriggerClass);
        const modalCloseEls = document.querySelectorAll(this.options.modalCloseClass);
        const body = document.querySelector('body');

        if(!modalTriggerEls || !modalContEl) return;

        for(let el of modalTriggerEls) {
            el.addEventListener('click', () => {
                modalContEl.classList.add('active');
                body.classList.add('modal-active');
            });
        }

        for(let el of modalCloseEls) {
            el.addEventListener('click', () => {
                modalContEl.classList.remove('active');
                body.classList.remove('modal-active');
            });
        }

        //Close by escape
        document.addEventListener("keydown", (e) => {
            if(e.key === "Escape") {
                modalContEl.classList.remove('active');
                body.classList.remove('modal-active');
            }
        });
    }
}